import { useForm } from '@mantine/form';
import Form from './forgotform';
import { validateEmail } from '../../helpers/common';
import { useNavigate } from 'react-router-dom';
import { userForgetPassword } from '../../store/actions';
import { useDispatch } from "react-redux";

const ForgotPassword = () => {
  const dispatch = useDispatch();

  const form = useForm({
    initialValues: {
      email: ""
    },
    validate: {
      email: (val: any) => (validateEmail(val))
    }
  });

  const submit = (e: any) => {
    e.preventDefault();
    form.validate();
    if (form.isValid()) {
      dispatch(userForgetPassword(form.values));
    }
  }

  return <Form formData={form} submit={submit} />;
};

export default ForgotPassword;


